import React, { SVGProps } from 'react';

const PropertyIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 17 15"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				d="M16.1566 7.00514L13.6316 4.67108V1.43764C13.6316 1.25848 13.5177 1.1175 13.3733 1.1175H11.9476C11.8024 1.1175 11.6892 1.25778 11.6892 1.43764V2.87584L9.35943 0.722404C8.83582 0.238365 8.01498 0.238365 7.49133 0.722404L0.693425 7.00511C0.44898 7.2308 0.434402 7.61206 0.660092 7.85581C0.885782 8.10026 1.26705 8.11484 1.5108 7.88915L8.30799 1.60716C8.37327 1.54674 8.47605 1.54674 8.54133 1.60716L15.3385 7.88915C15.4545 7.99609 15.601 8.04887 15.7469 8.04887C15.9087 8.04887 16.0705 7.98359 16.1892 7.85582C16.4163 7.61138 16.401 7.23085 16.1566 7.00514Z"
				fill="currentColor"
			/>
			<path
				d="M13.3969 14.6403C13.9492 14.6402 14.3968 14.1925 14.3968 13.6403V7.82692C14.3968 7.70817 14.3461 7.5929 14.2572 7.51096L8.6593 2.33724C8.52874 2.21571 8.32388 2.21571 8.19332 2.33724L2.59258 7.51096C2.50508 7.59221 2.45508 7.70749 2.45508 7.82692V13.6401C2.45508 14.1924 2.90279 14.6401 3.45508 14.6401H6.02666C6.57894 14.6401 7.02666 14.1924 7.02666 13.6401V11.0991C7.02666 10.3276 7.65514 9.7005 8.42736 9.7005C8.80029 9.7005 9.15167 9.84633 9.41626 10.1109C9.68085 10.3734 9.82598 10.7248 9.82598 11.0998V13.6407C9.82598 14.193 10.2738 14.6407 10.8261 14.6407L13.3969 14.6403Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default PropertyIcon;
